import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { AmountField } from '~/components';
import { Amount, Payroll } from '~/types';
import { useGetEmployeeById } from '~/hooks/employees';
import { Longdash } from '~/utils';

const Cell = ({ children }: any): JSX.Element => {
  return children;
};

interface ColoredAmountProps {
  amount: Amount | undefined;
}

const ColoredAmount: FC<ColoredAmountProps> = (props) => {
  const { amount } = props;
  return (
    <AmountField
      amount={amount}
      className={Number(amount?.value) > 0 ? `status-color__ACTIVE` : ''}
    />
  );
};

interface DescriptionProps {
  record: Payroll;
  className?: string;
}

const Description: FC<DescriptionProps> = (props) => {
  const { record, className } = props;

  return (
    <Space direction="vertical" size={4} className={className}>
      {record.description && <div>{record.description}</div>}
    </Space>
  );
};

const Employee: FC<DescriptionProps> = (props) => {
  const { record } = props;
  const employee = useGetEmployeeById(record?.actor?.id);
  return <div>{`${employee?.firstName ?? Longdash} ${employee?.lastName ?? Longdash}`}</div>;
};

Cell.ColoredAmount = ColoredAmount;
Cell.Description = styled(Description)`
  .Description-IconText {
    font-size: 12px;
  }
`;
Cell.Employee = Employee;

export default Cell;
